/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './game.defs.js'
export * as $defs from './game.defs.js'
